import React from 'react';
import R from 'ramda';
import { DeactivateDialog } from '../app/components';
import { connect } from 'react-redux';
import { updatePropertyWithImages } from '../../common/properties/actions';
import Property from './Property';

class Properties extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      confirmDeactivate: false,
      statusChangePropertyId: '',
    };
  }

  deactivateProperty = (e, propertyId) => {
    e.preventDefault();
    this.setState({ confirmDeactivate: true, statusChangePropertyId: propertyId });
  }

  render() {
    const { viewer, properties, updatePropertyWithImages } = this.props;
    const { confirmDeactivate, statusChangePropertyId } = this.state;

    return (
      <div className="properties">
        {properties.map((property, key) =>
          <Property
            from="/"
            key={key}
            viewer={viewer}
            property={property}
            presentational={false}
            deactivateProperty={this.deactivateProperty}
          />,
        )}
        <DeactivateDialog
          component={this}
          propertyId={statusChangePropertyId}
          confirmDeactivate={confirmDeactivate}
          updatePropertyWithImages={updatePropertyWithImages}
        />
      </div>
    );
  }
}

Properties.propTypes = {
  viewer: React.PropTypes.object,
  properties: React.PropTypes.array.isRequired,
  updatePropertyWithImages: React.PropTypes.func.isRequired,
};

export default R.compose(
  connect(
    state => ({
      viewer: state.users.viewer,
    }),
    { updatePropertyWithImages },
  ),
)(Properties);



// WEBPACK FOOTER //
// ./src/browser/properties/Properties.js